<template>
  <div class="animated fadeIn">
    <div class="mt-5 display-4 text-left">
      <span>Invite Contact</span>
    </div>
    <b-card class="mt-3">
      <b-alert v-if="error" :show="!!error" variant="warning">{{error}}</b-alert>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>@</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="text" class="form-control" placeholder="Email" autocomplete="email" v-model="email" />
      </b-input-group>
    </b-card>
    <div class="clearfix mb-5">
      <b-button variant="success" class="float-right" @click="sendInvite">Invite</b-button>
    </div>
  </div>
</template>

<script>
  import {AUTH_INVITE} from '@/store/action-types';
  import CustomerContactModel from "../../models/crm/CustomerContactModel";

  export default {
    components: {},
    name: 'ContactInvite',
    data() {
      return {
        error: null,
        email: null
      }
    },
    methods: {

      sendInvite: function() {
        this.$store.dispatch(AUTH_INVITE, {email: this.email}).then((user_id) => {
          let contact = new CustomerContactModel({
            customer_id: this.$store.getters.getAuthCustomerID,
            user_id,
            email: this.email
          });
          contact.save().then(() => {
            this.$router.push('/team');
          });
        }).catch(err => {
          const error = this.$store.getters.getAuthenticationError;
          if(error) {
            this.error = error
          } else {
            this.error = 'Something went wrong please contact an administrator.';
          }
        });
      },

    }
  }
</script>
